import axios from 'axios'

export const api = axios.create({
  baseURL: process.env.REACT_APP_GIANT_API_URL,
})


export const authApi = axios.create({
  baseURL: process.env.REACT_APP_GIANT_AUTH_API_URL,
  withCredentials: true
})

const errorHandler = (error) => {
  const statusCode = error.response?.status
  if (statusCode && statusCode !== 401) console.error(error)

  return Promise.reject(error)
}

api.interceptors.response.use(undefined, (error) => {
  return errorHandler(error)
})